export const dashedVid = (vid: string,prefixNum = 10,endNum = 20) => {
    if(vid.length <= 30) {
        return vid
    }

    let prefix = vid.slice(0, prefixNum)
    let end = vid.slice(vid.length-endNum, vid.length)
    return prefix + '......' + end
}



export const dateFormat = (str: string, fmt: string) => {
    let timestamp = parseInt(str)
    const date = new Date(timestamp)
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hours = date.getHours()
    const min = date.getMinutes()
    const second = date.getSeconds()
    const o: any = {
        'M+': month,
        'd+': day,
        'h+': hours,
        'm+': min,
        's+': second
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
        }
    }
    return fmt
}

export const hasData = (jsonData: any, type: string) => {
    let res="";
    let types = type.split(",");
    for(let index in types){
        if(jsonData[types[index]] && JSON.stringify(jsonData[types[index]]) !== '{}'){
            res = types[index];
            break;
        }
    }
    return res;
}

export const formatAddress = (gps: any) => {
    if (gps && gps !== undefined) {
      var addressList =
        (gps && [gps.city || "", gps.province || "", gps.country || ""]) || [];
      var country = (gps && gps.country) || "";
      if (country === "中国" || country === "中國") {
        addressList = addressList.reverse();
      }
      return addressList.join(" ");
    }
    return "";
  }
